class DocumentCard {
  section_documents;
  constructor() {
    this.section_documents = document.querySelectorAll('.documents__section');
    if (this.section_documents) {
      this.init();
    }
  }

  init() {
    this.section_documents.forEach((element) => {
      const title = element.querySelector('.documents__section-title');
      if (title) {
        title.addEventListener('click', (e) => {
          if (element.classList.contains('open')) {
            element.classList.remove('open');
          } else {
            element.classList.add('open');
          }
          e.stopPropagation();
        });
      }
    });
  }
}

export const documentCard = new DocumentCard();
